import './image-loader.scss';

import { Skeleton } from 'antd';
import { useState } from 'react';

interface IProps {
  src: string;
  fallbackSrc: string;
  alt?: string;
  width?: string;
  height?: string;
  className?: string;
  fallbackClassName?: string;
  min?: {
    width?: string;
    height?: string;
  };
}

const ImageLoader: React.FC<IProps> = ({
  src,
  fallbackSrc,
  alt = '',
  width = '80px',
  height = '80px',
  className = '',
  fallbackClassName = '',
  min
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <div
      className={`image-loader ${className}`}
      style={{
        width,
        height,
        ...(min && { minWidth: min.width, minHeight: min.height })
      }}
    >
      {loading ? (
        <Skeleton.Image
          active
          classNames={{
            root: 'image-loader__skeleton'
          }}
        />
      ) : (
        error && (
          <img
            className={`image-loader__image ${fallbackClassName}`}
            src={fallbackSrc}
            alt={alt}
          />
        )
      )}
      <img
        className={`image-loader__image ${loading || error ? 'image-loader__image--hidden' : ''}`}
        src={src}
        alt={alt}
        onError={() => {
          setLoading(false);
          setError(true);
        }}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default ImageLoader;
